module.exports = __webpack_public_path__ + "static/media/foodcoLogo.fa13603b.png";